export enum PSR_SUBMIT_TYPE {
	NORMAL = 'NORMAL',
	LEAVER = 'LEAVER',
}

export const psrPayrollScope = (isBureau: boolean) => ({
  paymentModels: isBureau ? ['PAYEE'] : ['PAYEE', 'UMBRELLA'],
  appName: isBureau ? 'BUREAU' : 'UMBRELLA',
});

export const prsiEeClasses = [
	{
		value: 'A0_A1',
		label: 'Class J0/A0/AX/AL/A1',
		desc: 'Employee aged 16 to 65',
	},
	{
		value: 'A8_A9',
		label: 'Class A8/A9',
		desc: 'Community Employment participant',
	},
	{
		value: 'J_16_65',
		label: 'Class J0/J1',
		desc: 'Employee aged 16 to 65 in subsidiary employment',
	},
	{
		value: 'J_OVER_65',
		label: 'Class J0/J1 (Over 65)',
		desc: 'Employee aged over 65',
	},
	{
		value: 'M_UNDER_15',
		label: 'Class M',
		desc: 'Employee aged 15 or under',
	},
	{
		value: 'M_PENSION',
		label: 'Class M (Pension)',
		desc: 'Employee in receipt of occupational pension',
	},
	{
		value: 'M_K1',
		label: 'Class M/K1',
		desc: 'Office holder',
	},
	{
		value: 'B',
		label: 'Class B',
		desc: 'Public sector employee',
	},
	{
		value: 'C',
		label: 'Class C',
		desc: 'Public sector employee',
	},
	{
		value: 'D',
		label: 'Class D',
		desc: 'Public sector employee',
	},
	{
		value: 'H',
		label: 'Class H',
		desc: 'Public sector employee',
	},
	{
		value: 'E',
		label: 'Class E',
		desc: 'Minister of religion employed by COI Representative Body',
	},
	{
		value: 'S',
		label: 'Class S',
		desc: 'Self-employed qualifying director',
	},
	{
		value: 'M_OVER_66',
		label: 'Class M (Over 66)',
		desc: 'Self-employed qualifying director aged 66 or over',
	},
];

export enum USC_EXEMPTION_TYPE {
	NOT_EXEMPT = 'NOT_EXEMPT',
	EXEMPT = 'EXEMPT',
}

export const uscExemptionOptions = [
	{ value: USC_EXEMPTION_TYPE.NOT_EXEMPT, label: 'Not Exempt from USC' },
	{ value: USC_EXEMPTION_TYPE.EXEMPT, label: 'Exempt from USC' },
];

export enum MEDICAL_INSURANCE_TYPE {
	ANNUAL = 'MEDICAL_INSURANCE_ANNUAL',
	ONE_OFF = 'MEDICAL_INSURANCE_ONE_OFF',
}

export const medicalInsuranceTypes = [
	{ label: 'Annual', value: MEDICAL_INSURANCE_TYPE.ANNUAL },
	{ label: 'One-off', value: MEDICAL_INSURANCE_TYPE.ONE_OFF },
];

// Mirrors the PSR list's Status column; the API filters on the same derivation.
export enum PSR_SUBMISSION_STATUS {
	SUCCESS = 'SUCCESS',
	UPDATED = 'UPDATED',
	WARNING = 'WARNING',
	FAILED = 'FAILED',
}
